import { useSidebarContext } from "../../context/SidebarContext";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { adminActions } from "../../store/adminSlice";
import { conflictCaseActions } from "../../store/conflictCasesSlice";
import { notificationActions } from "../../store/notificationsSlice";
import { signoutRedirect } from "../../auth/userServices";
import { initialSyncAsProvisionerAdminMiddleware } from "../../middleware/adminMiddleware";
import DropDown from "../../components/forms/DropDown";
import { BiLogOut } from "react-icons/bi";
import { Box } from "@mui/system";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { DisplayableValue } from "../../model/store/displayableValue";
import { authActions } from "../../store/authSlice";
import { useIsQueryPortalUser } from "../../hooks/useIsQueryPortalUser";
import { useIsNnsrPortalUser } from "../../hooks/useIsNnsrPortalUser";
import { useIsAdminUser } from "../../hooks/useIsAdminUser";
import { useIsCNAMPortalUser } from "../../hooks/useIsCnamPortalUser";

/**
 * Component of the sidebar which comes in and out when sidebar is enabled.
 *
 * @returns Component
 */
const SideBar = () => {
  const { showSidebar, setShowSidebar } = useSidebarContext();
  const navigate = useNavigate();
  const isAdminUser = useIsAdminUser();
  const isQueryPortalUser = useIsQueryPortalUser();
  const isNnsrPortalUser = useIsNnsrPortalUser();
  const isCnamPortalUser = useIsCNAMPortalUser();

  const redirectToPage = (page: string) => {
    if (isAdminUser()) {
      navigate(`/admin/${page}`);
    } else {
      navigate(`/${page}`);
    }
    setShowSidebar(false);
  };

  return (
    <>
      <div className={"sidebar " + (!showSidebar ? "hidden" : "visible")}>
        <div className="sidebar-section">
          {isNnsrPortalUser() && (
            <>
              {/**
               * NNSR Portal Sidebar Options (Admin and User)
               */}
              <div className="sidebar-header">NNSR Portal</div>

              <div
                className="sidebar-option"
                onClick={() => {
                  redirectToPage("caselist");
                }}
              >
                Cases
              </div>
              {isNnsrPortalUser(false) && (
                <>
                  <div
                    className="sidebar-option"
                    onClick={() => redirectToPage("newcase")}
                  >
                    New
                  </div>
                </>
              )}
              {isAdminUser() && (
                <>
                  <div
                    className="sidebar-option"
                    onClick={() => redirectToPage("provisioner-info")}
                  >
                    Provisioner Info
                  </div>
                  <div
                    className="sidebar-option"
                    onClick={() => redirectToPage("configurations")}
                  >
                    Portal Configurations
                  </div>
                </>
              )}
              <div
                className="sidebar-option"
                onClick={() => redirectToPage("querytn")}
              >
                Query TN
              </div>
              <div
                className="sidebar-option"
                onClick={() => redirectToPage("documentation")}
              >
                nnSR Documentation
              </div>
              {isNnsrPortalUser(false) && (
                <>
                  <div
                    className="sidebar-option"
                    onClick={() => redirectToPage("email-settings")}
                  >
                    Email Notifications Settings
                  </div>
                </>
              )}
            </>
          )}
          {/**
           * Query Service Sidebar Options
           */}
          {isQueryPortalUser() && (
            <>
              <div className="sidebar-header">Query</div>
              <div
                className="sidebar-option"
                onClick={() => redirectToPage("query-service/lookup")}
              >
                Number Lookup
              </div>
            </>
          )}

          {/**
           * CNAM Requests Sidebar Options
           */}
          {isCnamPortalUser(true) && (
            <>
              <div className="sidebar-header">Number Name</div>
              <div
                className="sidebar-option"
                onClick={() => redirectToPage("number-name/request")}
              >
                Number Name Request
              </div>
              <div
                className="sidebar-option"
                onClick={() => redirectToPage("number-name/lookup")}
              >
                Number Name Lookup
              </div>
            </>
          )}
        </div>
        <div className="sidebar-section">
          <div
            className="sidebar-option logout-option"
            onClick={() => {
              signoutRedirect();
            }}
          >
            <BiLogOut /> Logout
          </div>
        </div>
      </div>
    </>
  );
};

export default SideBar;
